import { getDeviceType } from '../hooks/useDeviceManager';
import { DataLayerEventList, DataLayerEventParamsMap } from './dataLayerEvents';

export const DATALAYER = window.dataLayer || [];

const pushDataLayerEvent = <T extends DataLayerEventList>(
	event: T,
	params?: DataLayerEventParamsMap[T],
	additionalProperties?: Record<string, any>,
) =>
	DATALAYER.push({
		event,
		...(params || {}),
		...getDeviceType(),
		...(additionalProperties || {}),
	});

type DataLayerPusherType<T extends DataLayerEventList> = DataLayerEventParamsMap[T] extends undefined
	? () => void
	: (params: DataLayerEventParamsMap[T]) => void;

export const dataLayerPusher = <T extends DataLayerEventList>(event: T): DataLayerPusherType<T> => {
	return (params?: DataLayerEventParamsMap[T]) => pushDataLayerEvent(event, params);
};

export const dataLayerPusherAsync = <T extends DataLayerEventList>(event: T) => {
	return async (params: DataLayerEventParamsMap[T], timeout = 1000) =>
		new Promise<void>((resolve) => {
			if (!(window as any).google_tag_manager) {
				resolve();
				return;
			}

			let timedOut = false;
			const timeoutId = setTimeout(() => {
				timedOut = true;
				resolve();
			}, timeout);

			pushDataLayerEvent(event, params, {
				eventCallback: () => {
					if (!timedOut) {
						clearTimeout(timeoutId);
						resolve();
					}
				},
				eventTimeout: timeout,
			});
		});
};
